import React, { FC } from 'react';
import { SVGProps } from '@utils';
import { SvgWrapper } from './SvgWrapper';

export const LogoutIcon: FC<SVGProps> = ({ onClick, divClassName }) => (
  <SvgWrapper
    divClassName={divClassName}
    onClick={onClick}
  >
    <svg 
      width="15" 
      height="17" 
      viewBox="0 0 15 17" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <path 
        d="M1.25 17C0.916667 17 0.625 16.8587 0.375 16.5762C0.125 16.2936 0 15.964 0 15.5873V10.6427H1.25V15.5873H13.75V1.41274H1.25V6.40443H0V1.41274C0 1.03601 0.125 0.706371 0.375 0.423823C0.625 0.141274 0.916667 0 1.25 0H13.75C14.0833 0 14.375 0.141274 14.625 0.423823C14.875 0.706371 15 1.03601 15 1.41274V15.5873C15 15.964 14.875 16.2936 14.625 16.5762C14.375 16.8587 14.0833 17 13.75 17H1.25ZM6.10417 13.0679L5.16667 12.0083L7.625 9.22992H0V7.81718H7.625L5.16667 5.03878L6.10417 3.97922L10.125 8.52355L6.10417 13.0679Z" 
        fill="#434649" 
        fillOpacity="0.85"
      />
    </svg>
  </SvgWrapper>
);